import { AdaPolicyId } from "../cardano/constants";
/** ADA in Lovelace units or any other asset.
 */
export class AssetAmount {
    constructor(asset, amount) {
        this.asset = asset;
        this.amount = amount;
    }
    withAmount(amount) {
        return new AssetAmount(this.asset, amount);
    }
    add(x) {
        return new AssetAmount(this.asset, this.amount + x);
    }
    get isAda() {
        return this.asset.policyId === AdaPolicyId;
    }
    get toEntry() {
        return {
            ...this.asset,
            quantity: this.amount
        };
    }
    static fromEntry(entry) {
        return new AssetAmount({ policyId: entry.policyId, name: entry.name }, entry.quantity);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXRBbW91bnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZG9tYWluL2Fzc2V0QW1vdW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBQyxXQUFXLEVBQUMsTUFBTSxzQkFBc0IsQ0FBQTtBQUloRDtHQUNHO0FBQ0gsTUFBTSxPQUFPLFdBQVc7SUFDdEIsWUFBNEIsS0FBaUIsRUFBa0IsTUFBYztRQUFqRCxVQUFLLEdBQUwsS0FBSyxDQUFZO1FBQWtCLFdBQU0sR0FBTixNQUFNLENBQVE7SUFBRyxDQUFDO0lBRWpGLFVBQVUsQ0FBQyxNQUFjO1FBQ3ZCLE9BQU8sSUFBSSxXQUFXLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRSxNQUFNLENBQUMsQ0FBQTtJQUM1QyxDQUFDO0lBRUQsR0FBRyxDQUFDLENBQVM7UUFDWCxPQUFPLElBQUksV0FBVyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsSUFBSSxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQTtJQUNyRCxDQUFDO0lBRUQsSUFBSSxLQUFLO1FBQ1AsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsS0FBSyxXQUFXLENBQUE7SUFDNUMsQ0FBQztJQUVELElBQUksT0FBTztRQUNULE9BQU87WUFDTCxHQUFHLElBQUksQ0FBQyxLQUFLO1lBQ2IsUUFBUSxFQUFFLElBQUksQ0FBQyxNQUFNO1NBQ3RCLENBQUE7SUFDSCxDQUFDO0lBRUQsTUFBTSxDQUFDLFNBQVMsQ0FBQyxLQUFpQjtRQUNoQyxPQUFPLElBQUksV0FBVyxDQUFDLEVBQUMsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLEVBQUUsSUFBSSxFQUFFLEtBQUssQ0FBQyxJQUFJLEVBQUMsRUFBRSxLQUFLLENBQUMsUUFBUSxDQUFDLENBQUE7SUFDdEYsQ0FBQztDQUNGIn0=